import { MutableRefObject, useMemo } from 'react';

import { QuillWrapper } from '@labradorsports/components';

interface Props {
    value?: string;
    resultRef: MutableRefObject<AnyFunction>;
}

const formats = ['bold', 'italic', 'underline', 'list', 'link'];

const BasicTextEditor: FC<Props> = ({ value, resultRef }) => {
    const id = useMemo(() => Math.random().toString().replace('.', ''), []);

    // If the modules or formats change on every render, the entire Quill editor will re-render and cause issues
    const modulesRef = useMemo(
        () => ({
            toolbar: {
                container: `.basic-text-editor-${id} .ql-toolbar`,
            },
        }),
        []
    );

    return (
        <div className={`basic-text-editor basic-text-editor-${id}`}>
            <div className="ql-toolbar">
                <button type="button" className="ql-bold" />
                <button type="button" className="ql-italic" />
                <button type="button" className="ql-underline" />
                <button type="button" className="ql-list" value="ordered" />
                <button type="button" className="ql-list" value="bullet" />
            </div>
            <QuillWrapper resultRef={resultRef} defaultValue={value} formats={formats} modules={modulesRef} />
        </div>
    );
};

export default BasicTextEditor;
